import { render } from "./ObjectPath.vue?vue&type=template&id=7b2ff2cb"
import script from "./ObjectPath.vue?vue&type=script&lang=js"
export * from "./ObjectPath.vue?vue&type=script&lang=js"

import exportComponent from "/vercel/path0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__